// Human-readable label for an AWS resource (CloudFormation) type, matching the
// resource-type filter's derivation: "AWS::S3::Bucket" -> "S3 Bucket". Anything
// not shaped like Provider::Service::Resource is shown verbatim.
export function assetTypeLabel(assetType: string): string {
  const parts = assetType.split('::');
  if (parts.length !== 3) {
    return assetType;
  }
  const [, service, resource] = parts;
  return `${service} ${resource}`;
}
